"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_1 = require("react");
var categoriesContext_1 = require("../../context/admin/categoriesContext");
var buttons_1 = require("../buttons");
var generic_1 = require("../generic");
var dragAndDrop_1 = require("../lib/dragAndDrop");
var utils_1 = require("./utils");
var importCategoriesContext_1 = require("../../context/admin/importCategoriesContext");
var importCategories_1 = require("./importCategories");
var typestyle_1 = require("typestyle");
var iterUtils_1 = require("../lib/iterUtils");
var forms_1 = require("../lib/forms");
var CategoryDisplay = function (props) {
    var _a = __read((0, react_1.useState)(props.value), 2), tempValue = _a[0], setTempValue = _a[1];
    var now = new Date();
    var id = props.id || "new-".concat(now.getTime());
    return (React.createElement("div", { className: (0, typestyle_1.classes)(props.className, "input-group") },
        props.mandatory &&
            React.createElement(generic_1.Icon, { className: "asterisk", name: generic_1.Icons.asterisk }),
        props.mutuallyExclusive &&
            React.createElement(generic_1.Icon, { className: "tag ml-1", name: generic_1.Icons.tag }),
        React.createElement("input", { type: "text", id: "category_textbox", className: (0, typestyle_1.classes)(props.inputClassName, "input-text", "form-control"), onBlur: props.onBlur, onChange: function (e) { return setTempValue(e.currentTarget.value); }, disabled: !props.editable, value: tempValue, ref: function (me) {
                if (me && props.autofocus)
                    me.focus();
            } }),
        React.createElement(buttons_1.ActionButton, { disabled: !props.editable || !props.deletable, onClick: props.onDelete },
            React.createElement(generic_1.Icon, { name: generic_1.Icons.delete })),
        props.onAddTag &&
            React.createElement(buttons_1.ActionButton, { disabled: !props.editable, onClick: function () { return props.onAddTag(); } },
                React.createElement(generic_1.Icon, { name: generic_1.Icons.plus_circle })),
        props.onAddTag && props.editable &&
            React.createElement("div", { className: "dropdown", id: "valueItemDrop" },
                React.createElement("button", { className: "btn btn-link dropdown-toggle", type: "button", "data-toggle": "dropdown", "aria-haspopup": "true", "aria-expanded": "true" },
                    React.createElement(generic_1.Icon, { name: generic_1.Icons.cog })),
                React.createElement("ul", { className: "dropdown-menu", onClick: function (event) { return event.stopPropagation(); } },
                    React.createElement("li", { className: "checkbox form-group form-inline" },
                        React.createElement(forms_1.InputSwitch, { id: "mandatory-".concat(id), checked: props.mandatory, onChange: props.onChangeMandatory, labelClasses: "ml-2", labelText: gettext("Mandatory") })),
                    React.createElement("li", { className: "checkbox form-group form-inline" },
                        React.createElement(forms_1.InputSwitch, { id: "mutually-".concat(id), checked: props.mutuallyExclusive, onChange: props.onChangeExclusive, labelClasses: "ml-2", labelText: gettext("Mutually Exclusive") }))))));
};
var TagContainer = function (props) {
    return (React.createElement(categoriesContext_1.default.Consumer, null, function (context) {
        var tag = props.tag;
        var onBlurTag = function (tag) { return function (e) {
            context.onEditTag(e.currentTarget.value, props.category, tag);
        }; };
        return (React.createElement(CategoryDisplay, { value: tag.name, id: tag.id, editable: tag.editable, deletable: tag.deletable, autofocus: tag.autofocus, className: "TagDisplay", inputClassName: "TagDisplay__Text", onBlur: onBlurTag(tag), onDelete: function () { return context.onDeleteTag(props.category, tag); } }));
    }));
};
var TagList = function (props) {
    return (React.createElement(categoriesContext_1.default.Consumer, null, function (context) {
        return (React.createElement("ul", { className: "TagList" }, props.tags.map(function (tag, index) {
            var moveTag = function (draggedTag) {
                var from = props.category.tags.indexOf(draggedTag);
                var to = index;
                if (from === to)
                    return;
                context.reOrderTag(props.category, from, to);
            };
            return (React.createElement(dragAndDrop_1.DragListItem, { key: (0, utils_1.getTagUniqueKey)(props.category, tag), className: "TagItem", disabled: !tag.editable, dragItem: tag, accept: tag.type, moveItem: moveTag, canDrop: function (droppedTag) { return (0, iterUtils_1.contains)(props.category.tags, droppedTag); } },
                React.createElement(TagContainer, { category: props.category, tag: tag, ordering: index })));
        })));
    }));
};
var CategoryContainer = function (props) {
    var category = props.category;
    return (React.createElement(categoriesContext_1.default.Consumer, null, function (context) {
        var onBlurCategory = function (e) {
            context.onEditCategory(e.currentTarget.value, category);
        };
        return (React.createElement(React.Fragment, null,
            React.createElement(CategoryDisplay, { value: category.name, id: category.id, editable: category.editable, deletable: category.deletable, className: "CategoryDisplay", inputClassName: "CategoryDisplay__Text", autofocus: category.autofocus, onBlur: onBlurCategory, onDelete: function () { return context.onDeleteCategory(category); }, onAddTag: function () { return context.onCreateTag(category); }, mandatory: category.mandatory, onChangeMandatory: function (e) { return context.onChangeMandatoryCategory(e.currentTarget.checked, category); }, mutuallyExclusive: category.mutuallyExclusive, onChangeExclusive: function (e) { return context.onChangeMutuallyExclusive(e.currentTarget.checked, category); } }),
            React.createElement(TagList, { category: category, tags: category.tags })));
    }));
};
var CategoryList = function (props) {
    return (React.createElement(categoriesContext_1.default.Consumer, null, function (context) {
        return (React.createElement("ul", { className: "CategoryList" }, props.categories.map(function (category, index) {
            var moveCategory = function (draggedCategory) {
                var from = context.categories.indexOf(draggedCategory);
                var to = index;
                if (from === to)
                    return;
                context.reOrderCategory(from, to);
            };
            return (React.createElement(dragAndDrop_1.DragListItem, { key: (0, utils_1.getCategoryUniqueKey)(category), className: "CategoryItem", dragItem: category, accept: category.type, moveItem: moveCategory, canDrop: function (droppedCategory) { return (0, iterUtils_1.contains)(props.categories, droppedCategory); } },
                React.createElement(CategoryContainer, { category: category, ordering: index })));
        })));
    }));
};
var CategoriesAppContent = (function (_super) {
    __extends(CategoriesAppContent, _super);
    function CategoriesAppContent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CategoriesAppContent.prototype.componentDidMount = function () {
        this.context.fetchAll();
    };
    CategoriesAppContent.prototype.render = function () {
        var _this = this;
        return (React.createElement(importCategoriesContext_1.default.Consumer, null, function (importContext) {
            return React.createElement("div", { className: "CategoriesApp" },
                React.createElement("div", { className: "CategoriesApp__Header" },
                    React.createElement(buttons_1.ActionButton, { disabled: !_this.context.can_add_category, onClick: _this.context.onCreateCategory },
                        React.createElement(generic_1.Icon, { name: generic_1.Icons.plus_circle }),
                        "\u00A0",
                        gettext("New Category")),
                    React.createElement(buttons_1.ActionButton, { disabled: !_this.context.can_add_category, onClick: importContext.openDialog },
                        React.createElement(generic_1.Icon, { name: generic_1.Icons.copy }),
                        "\u00A0",
                        gettext("Copy from project"))),
                React.createElement("div", { className: "CategoriesApp__ScrollWrapper" },
                    React.createElement(dragAndDrop_1.DndAutoScroll, { scrollParentId: ".CategoriesApp__ScrollWrapper" },
                        React.createElement(CategoryList, { categories: _this.context.categories }))),
                React.createElement("div", { className: "CategoriesApp__Footer" },
                    React.createElement(generic_1.FloatRight, null,
                        React.createElement(buttons_1.PrimaryButton, { onClick: function () { return _this.context.onSave(false); } }, gettext("Save")))),
                React.createElement(importCategories_1.ImportCategoriesDialog, { onSaveSuccess: _this.context.fetchAll }));
        }));
    };
    CategoriesAppContent.contextType = categoriesContext_1.default;
    return CategoriesAppContent;
}(React.Component));
var CategoriesApp = function (props) {
    return (React.createElement("div", { className: "row" },
        React.createElement("div", { className: "col-2 hidden-md hidden-lg" },
            React.createElement("ul", { className: "nav flex-column nav-pills" },
                React.createElement("li", { className: "nav-item" },
                    React.createElement("a", { className: "nav-link active", id: "pills-risks-tab", "data-toggle": "pill", href: "#pills-risks", role: "tab", "aria-controls": "pills-risks", "aria-selected": "true" }, gettext("Risks"))),
                React.createElement("li", { className: "nav-item" },
                    React.createElement("a", { className: "nav-link", id: "pills-controls-actions-tab", "data-toggle": "pill", href: "#pills-controls-actions", role: "tab", "aria-controls": "pills-controls-actions", "aria-selected": "true" }, gettext("Controls & Actions"))))),
        React.createElement("div", { className: "col" },
            React.createElement("div", { className: "tab-content row", id: "v-pills-tabContent" },
                React.createElement("div", { className: "tab-pane fade show active col", id: "pills-risks", role: "tabpanel", "aria-labelledby": "pills-risks-tab" },
                    React.createElement(categoriesContext_1.CategoriesContextProvider, { project_id: props.project_id, is_control_action: false },
                        React.createElement(importCategoriesContext_1.ImportCategoriesContextProvider, { project_id: props.project_id, is_control_action: false },
                            React.createElement(dragAndDrop_1.DndContainer, null,
                                React.createElement(dragAndDrop_1.DndAutoScroll, null,
                                    React.createElement(CategoriesAppContent, null)))))),
                React.createElement("div", { className: "tab-pane fade col", id: "pills-controls-actions", role: "tabpanel", "aria-labelledby": "pills-controls-actions-tab" },
                    React.createElement(categoriesContext_1.CategoriesContextProvider, { project_id: props.project_id, is_control_action: true },
                        React.createElement(importCategoriesContext_1.ImportCategoriesContextProvider, { project_id: props.project_id, is_control_action: true },
                            React.createElement(dragAndDrop_1.DndContainer, null,
                                React.createElement(CategoriesAppContent, null)))))))));
};
exports.default = CategoriesApp;
